import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import cx from 'classnames';
import styles from './styles.module.scss';

const Tooltip = ({
	children,
	id,
	content,
	className,
	float,
	noArrow,
	...props
}) => (
	<div className={styles.Tooltip_Container}>
		<ReactTooltip
			className={cx(styles.Tooltip__override, className)}
			{...{
				float,
				noArrow,
				id,
				content,
				...props
			}}
		>
			{children}
		</ReactTooltip>
	</div>
);

Tooltip.propTypes = {
	id: PropTypes.string,
	content: PropTypes.string,
	children: PropTypes.node,
	className: PropTypes.string,
	float: PropTypes.bool,
	noArrow: PropTypes.bool
};

export default Tooltip;
